import jscookie from 'js-cookie'
import { AUTH_API_COOKIE } from '../modules/user'

const state = {
	selectedDept: null,
	selectedCollege: null,
	employees: null,
}

const mutations = {
	setSelectedDept(state, payload) {
		state.selectedDept = payload
	},

	setSelectedCollege(state, payload) {
		state.selectedCollege = payload
	},

	setEmployees(state, payload) {
		state.employees = payload
	},
}

const actions = {

	fetchDeptOccupantPIs ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/dept/employees/' + payload, {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
                    'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setEmployees', data) 
		        resolve(data)
		      })
		})
	},
	fetchCollegeOccupantPIs ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action:  ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/employee/college/' + payload, {      
		      headers: { 
		      		'database' : getters.getDatabase(),
		            'apiEsriToken' : apiEsriToken,
		            'content-type': 'application/json',
                    'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setEmployees', data) 
		        resolve(data)
		      })
		})
	},

};

const getters = {
/*	getDept: state => () => {
		return state.room.pct[deptSelectedIndex];
	}*/
};

export default {
	state,
	getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js